/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesImportsApplicationContractsImportSourceTournamentResponse } from '../model/modulesImportsApplicationContractsImportSourceTournamentResponse';
import { ModulesImportsApplicationContractsSourceCourseResponse } from '../model/modulesImportsApplicationContractsSourceCourseResponse';
import { ModulesImportsApplicationContractsSourcePlayerResponse } from '../model/modulesImportsApplicationContractsSourcePlayerResponse';
import { ModulesImportsApplicationContractsSourceTournamentResponse } from '../model/modulesImportsApplicationContractsSourceTournamentResponse';
import { ModulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse } from '../model/modulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse';
import { ModulesImportsEndpointsContractsImportPointsRaceRequestModel } from '../model/modulesImportsEndpointsContractsImportPointsRaceRequestModel';
import { ModulesImportsEndpointsPlayersImportPlayersFromXmlResponse } from '../model/modulesImportsEndpointsPlayersImportPlayersFromXmlResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ImportsServiceInterface }                            from './imports.serviceInterface';


@Injectable()
export class ImportsService implements ImportsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets Courses for an Import Source (LPGA, etc.) and Tournament Id.
     * Gets Courses for an Import Source (LPGA, etc.) and Tournament Id.
     * @param sourceType 
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCoursesBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesImportsApplicationContractsSourceCourseResponse>>;
    public getCoursesBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesImportsApplicationContractsSourceCourseResponse>>>;
    public getCoursesBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesImportsApplicationContractsSourceCourseResponse>>>;
    public getCoursesBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling getCoursesBySourceTournamentIdEndpoint.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getCoursesBySourceTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesImportsApplicationContractsSourceCourseResponse>>('get',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/courses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Players for an Import Source (LPGA, etc.) and Tournament Id.
     * Gets Players for an Import Source (LPGA, etc.) and Tournament Id.
     * @param sourceType 
     * @param tournamentId 
     * @param replaceExisting 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayersBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>;
    public getPlayersBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>>;
    public getPlayersBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>>;
    public getPlayersBySourceTournamentIdEndpoint(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling getPlayersBySourceTournamentIdEndpoint.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getPlayersBySourceTournamentIdEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (replaceExisting !== undefined && replaceExisting !== null) {
            queryParameters = queryParameters.set('replaceExisting', <any>replaceExisting);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>('get',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/players`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Players for an Import Source (LPGA, etc.)
     * Gets Players for an Import Source (LPGA, etc.)
     * @param sourceType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSourcePlayersEndpoint(sourceType: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>;
    public getSourcePlayersEndpoint(sourceType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>>;
    public getSourcePlayersEndpoint(sourceType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>>;
    public getSourcePlayersEndpoint(sourceType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling getSourcePlayersEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesImportsApplicationContractsSourcePlayerResponse>>('get',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Tournaments for an Import Source (LPGA, etc.).
     * Gets Tournaments for an Import Source (LPGA, etc.).
     * @param sourceType 
     * @param season 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSourceTournamentsEndpoint(sourceType: string, season?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesImportsApplicationContractsSourceTournamentResponse>>;
    public getSourceTournamentsEndpoint(sourceType: string, season?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesImportsApplicationContractsSourceTournamentResponse>>>;
    public getSourceTournamentsEndpoint(sourceType: string, season?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesImportsApplicationContractsSourceTournamentResponse>>>;
    public getSourceTournamentsEndpoint(sourceType: string, season?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling getSourceTournamentsEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (season !== undefined && season !== null) {
            queryParameters = queryParameters.set('season', <any>season);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesImportsApplicationContractsSourceTournamentResponse>>('get',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports Courses for a Tournament from the Source using the (Source) TournamentId.
     * Imports Courses for a Tournament from the Source using the (Source) TournamentId.
     * @param sourceType 
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsSourceTypeTournamentsTournamentIdCoursesPost(sourceType: string, tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public importsSourceTypeTournamentsTournamentIdCoursesPost(sourceType: string, tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public importsSourceTypeTournamentsTournamentIdCoursesPost(sourceType: string, tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public importsSourceTypeTournamentsTournamentIdCoursesPost(sourceType: string, tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling importsSourceTypeTournamentsTournamentIdCoursesPost.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsSourceTypeTournamentsTournamentIdCoursesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/courses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports missing PointsRacePlayers for a Tournament from the Source using the (Source) TournamentId.
     * Imports missing PointsRacePlayers for a Tournament from the Source using the (Source) TournamentId.
     * @param sourceType 
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost(sourceType: string, tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost(sourceType: string, tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost(sourceType: string, tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost(sourceType: string, tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsSourceTypeTournamentsTournamentIdMissingPointsRacePlayersPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/missing-points-race-players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports Players for a Tournament from the Source using the (Source) TournamentId.
     * Imports Players for a Tournament from the Source using the (Source) TournamentId.
     * @param sourceType 
     * @param tournamentId 
     * @param replaceExisting 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsSourceTypeTournamentsTournamentIdPlayersPost(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public importsSourceTypeTournamentsTournamentIdPlayersPost(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public importsSourceTypeTournamentsTournamentIdPlayersPost(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public importsSourceTypeTournamentsTournamentIdPlayersPost(sourceType: string, tournamentId: string, replaceExisting?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling importsSourceTypeTournamentsTournamentIdPlayersPost.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsSourceTypeTournamentsTournamentIdPlayersPost.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (replaceExisting !== undefined && replaceExisting !== null) {
            queryParameters = queryParameters.set('replaceExisting', <any>replaceExisting);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/players`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports PointsRaceRankings for a Tournament from the Source using the (Source) TournamentId.
     * Imports PointsRaceRankings for a Tournament from the Source using the (Source) TournamentId.
     * @param sourceType 
     * @param tournamentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost(sourceType: string, tournamentId: string, body?: ModulesImportsEndpointsContractsImportPointsRaceRequestModel, observe?: 'body', reportProgress?: boolean): Observable<ModulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse>;
    public importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost(sourceType: string, tournamentId: string, body?: ModulesImportsEndpointsContractsImportPointsRaceRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse>>;
    public importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost(sourceType: string, tournamentId: string, body?: ModulesImportsEndpointsContractsImportPointsRaceRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse>>;
    public importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost(sourceType: string, tournamentId: string, body?: ModulesImportsEndpointsContractsImportPointsRaceRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsSourceTypeTournamentsTournamentIdPointsRaceRankingsPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesImportsApplicationSourcesLPGAPointsRacesImportPointsRaceRankingsImportPointsRaceRankingsResponse>('post',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}/points-race-rankings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports a Tournament from the Source using the (Source) TournamentId.
     * Imports a Tournament from the Source using the (Source) TournamentId.
     * @param sourceType 
     * @param tournamentId 
     * @param includeCourses 
     * @param includePlayers 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsSourceTypeTournamentsTournamentIdPost(sourceType: string, tournamentId: string, includeCourses?: boolean, includePlayers?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ModulesImportsApplicationContractsImportSourceTournamentResponse>;
    public importsSourceTypeTournamentsTournamentIdPost(sourceType: string, tournamentId: string, includeCourses?: boolean, includePlayers?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesImportsApplicationContractsImportSourceTournamentResponse>>;
    public importsSourceTypeTournamentsTournamentIdPost(sourceType: string, tournamentId: string, includeCourses?: boolean, includePlayers?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesImportsApplicationContractsImportSourceTournamentResponse>>;
    public importsSourceTypeTournamentsTournamentIdPost(sourceType: string, tournamentId: string, includeCourses?: boolean, includePlayers?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sourceType === null || sourceType === undefined) {
            throw new Error('Required parameter sourceType was null or undefined when calling importsSourceTypeTournamentsTournamentIdPost.');
        }

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsSourceTypeTournamentsTournamentIdPost.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (includeCourses !== undefined && includeCourses !== null) {
            queryParameters = queryParameters.set('includeCourses', <any>includeCourses);
        }
        if (includePlayers !== undefined && includePlayers !== null) {
            queryParameters = queryParameters.set('includePlayers', <any>includePlayers);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesImportsApplicationContractsImportSourceTournamentResponse>('post',`${this.basePath}/imports/${encodeURIComponent(String(sourceType))}/tournaments/${encodeURIComponent(String(tournamentId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports Players for a Tournament from an XML file.
     * Uploads an XML file containing player data and imports them as Tournament Players.
     * @param tournamentId 
     * @param file 
     * @param replaceExisting 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importsXmlTournamentsTournamentIdPlayersPostForm(tournamentId: string, file?: Blob, replaceExisting?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ModulesImportsEndpointsPlayersImportPlayersFromXmlResponse>;
    public importsXmlTournamentsTournamentIdPlayersPostForm(tournamentId: string, file?: Blob, replaceExisting?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesImportsEndpointsPlayersImportPlayersFromXmlResponse>>;
    public importsXmlTournamentsTournamentIdPlayersPostForm(tournamentId: string, file?: Blob, replaceExisting?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesImportsEndpointsPlayersImportPlayersFromXmlResponse>>;
    public importsXmlTournamentsTournamentIdPlayersPostForm(tournamentId: string, file?: Blob, replaceExisting?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling importsXmlTournamentsTournamentIdPlayersPost.');
        }



        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }
        if (replaceExisting !== undefined) {
            formParams = formParams.append('replaceExisting', <any>replaceExisting) as any || formParams;
        }

        return this.httpClient.request<ModulesImportsEndpointsPlayersImportPlayersFromXmlResponse>('post',`${this.basePath}/imports/xml/tournaments/${encodeURIComponent(String(tournamentId))}/players`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
